// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".property_detail_summary[data-v-ed22fcd0]{line-height:1.7}", "",{"version":3,"sources":["webpack://./resources/client/modules/lead/sections/LeadPropertyDetails.vue"],"names":[],"mappings":"AAGA,0CACE,eAFF","sourcesContent":["\n@import \"../../../styles/variables/variables\";\n\n.property_detail_summary {\n  line-height: 1.7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
